// 82ZONE product rail: category tabs and previous/next scrolling. No dependencies.
class ProductRail extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    const { signal } = this.abort;
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.panels = [...this.querySelectorAll('[role="tabpanel"]')];

    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.select(i), { signal });
      tab.addEventListener('keydown', (event) => {
        const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
        if (!step) return;
        event.preventDefault();
        const next = (i + step + this.tabs.length) % this.tabs.length;
        this.select(next);
        this.tabs[next].focus();
      }, { signal });
    });

    this.querySelectorAll('[data-rail-step]').forEach((button) =>
      button.addEventListener('click', () => {
        const track = this.activeTrack();
        if (!track || !track.children.length) return;
        const direction = Number(button.dataset.railStep);
        // Move by whole cards so a set of 4 always lines up.
        // Fractional boxes: rounded offsetLeft/offsetWidth can make 4 cards look wider than the track.
        const first = track.children[0].getBoundingClientRect();
        const second = track.children[1]?.getBoundingClientRect();
        const step = second ? second.left - first.left : first.width;
        // The last visible card has no gap after it, so add one gap before dividing (4 cards + 3 gaps = the track width).
        const gap = step - first.width;
        const visible = Math.max(1, Math.floor((track.clientWidth + gap) / step + 0.01));
        track.scrollBy({ left: direction * visible * step, behavior: 'smooth' });
      }, { signal })
    );

    this.steps = [...this.querySelectorAll('[data-rail-step]')];
    this.resizeObserver = new ResizeObserver(() => this.updateSteps());
    this.querySelectorAll('.rail__track').forEach((track) => this.resizeObserver.observe(track));
  }

  // Hide previous/next when the visible rail does not overflow.
  updateSteps() {
    const track = this.activeTrack();
    const overflows = track && track.scrollWidth > track.clientWidth + 1;
    this.steps.forEach((step) => (step.hidden = !overflows));
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.abort?.abort();
  }

  activeTrack() {
    const panel = this.panels.find((p) => !p.hidden) || this;
    return panel.querySelector('.rail__track');
  }

  select(index) {
    this.tabs.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    this.panels.forEach((panel, i) => (panel.hidden = i !== index));
    this.updateSteps();
  }
}

if (!customElements.get('product-rail')) customElements.define('product-rail', ProductRail);
